var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgLogoNoText = function SvgLogoNoText(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "tea-logo",
    width: 345,
    height: 345,
    viewBox: "0 0 345 345",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_38)",
    transform: "translate(0, 72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8163 113.567L63.9223 149.083C69.9647 153.529 78.6042 151.764 82.9329 145.536C87.2438 139.308 85.53 130.434 79.47 126.006L29.364 89.6083L28.4982 88.7262V86.9619L29.364 86.0797L79.47 49.6824C85.5124 45.2364 87.2438 36.362 82.9329 30.1517C80.3357 26.6055 76.0247 23.9238 71.6961 23.9238C69.0989 23.9238 66.5194 24.8059 63.9223 26.6055L13.8163 62.0854C5.17668 67.3959 0 76.2879 0 86.9442C0 99.3648 5.17668 108.257 13.8163 113.567Z",
    fill: "#74FAD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.385 0.864502C308.746 3.82851 304.929 11.7149 306.82 20.5716C306.82 21.5596 331.767 110.286 280.919 170.448C275.159 177.346 276.113 187.209 282.844 193.137C285.707 196.101 289.558 197.071 293.41 197.071C297.261 197.071 302.049 195.095 304.912 191.143C367.279 117.202 338.498 15.6493 337.544 11.6972C334.682 2.82286 326.042 -2.09951 317.403 0.846859H317.385V0.864502Z",
    fill: "#74FAD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.152 20.5716C137.014 11.6972 132.226 3.81087 123.587 0.864502C114.947 -2.08186 107.279 2.84051 104.399 11.7149C103.445 15.6493 74.6643 117.219 137.032 191.161C139.894 195.095 144.7 197.089 148.534 197.089C152.367 197.089 156.201 196.083 159.099 193.155C165.813 187.227 165.813 177.382 161.025 170.466C109.223 110.321 134.152 21.5949 134.152 20.5893V20.5716Z",
    fill: "#74FAD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.276 168.472H190.742C182.102 168.472 175.389 175.37 175.389 184.245C175.389 193.119 182.102 200.018 190.742 200.018H250.23C258.869 200.018 265.583 193.119 265.583 184.245C264.629 175.37 257.915 168.472 249.276 168.472Z",
    fill: "#74FAD1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_38"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 345,
    height: 345,
    fill: "white"
  })))));
};
export default SvgLogoNoText;